export default "__VITE_ASSET__Dixdbpwt__"